import { Component, EventEmitter, Input, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { IStep } from "../../data-types/steps.interface";
import { IAppState } from "../../store/state/app.state";
@Component({
  selector: "cowing-core-coworking-stepper",
  templateUrl: "./coworking-stepper.component.html",
  styleUrls: ["./coworking-stepper.component.scss"],
})
export class CoworkingStepperComponent implements OnInit {
  @Input("steps") steps: Array<IStep>;

  constructor(private _store: Store<IAppState>) {}
  ngOnInit() {
    console.log(this.steps);
  }
}
